<template>
    <b-card
        v-if="show"
        bg-variant="light"
        no-body
        class="text-dark p-2 mb-3 shadow-sm"
    >
        <div class="row">
            <div class="col-10">
                <p class="comment-created">
                    {{ comment.type.name }} :
                    <span class="font-italic"
                        >{{ comment.created_at_for_humans }} par
                        {{ comment.created_by.name }}</span
                    >
                </p>
            </div>
            <div class="col-2 text-right">
                <b-link
                    v-if="comment.can_edit && !editing"
                    :key="'delete-link' + comment.id"
                    class="text-danger"
                    @click="deleteComment"
                >
                    <i class="fas fa-fw fa-trash-alt"></i>
                </b-link>
                <b-link
                    v-if="comment.can_edit && editing"
                    :key="'save-link' + comment.id"
                    class="text-success"
                    @click="updateComment"
                >
                    <i class="fas fa-fw fa-save"></i>
                </b-link>
            </div>
        </div>

        <hr class="mb-1 mt-1" />
        <p
            v-if="!editing"
            title="Cliquer pour modifier"
            class="mb-0"
            style="cursor: pointer"
            @click="editForm"
        >
            {{ form.description }}
        </p>
        <b-form-select
            v-if="editing"
            v-model="form.type"
            size="sm"
            :options="typeOptions"
            class="mb-1"
        >
        </b-form-select>
        <b-form-textarea
            v-if="editing"
            v-model="form.description"
            rows="2"
            max-rows="6"
            class="mb-0"
            :disabled="!comment.can_edit"
            @change="updateComment"
        ></b-form-textarea>
    </b-card>
</template>

<script>
export default {
    name: 'CommentHandler',

    props: {
        comment: {},
    },

    data() {
        return {
            show: true,
            form: {},
            editing: false,
            description: '',
            typeOptions: [
                { value: 'bil', text: 'BILAN' },
                { value: 'cac', text: 'CAC' },
                { value: 'oth', text: 'DIVERS' },
                { value: 'iss', text: 'IS' },
                { value: 'jdc', text: 'JE DECLARE' },
                { value: 'sit', text: 'SITUATION' },
                { value: 'tax', text: 'TAXES' },
                { value: 'ten', text: 'TENUE' },
                { value: 'vat', text: 'TVA' },
                { value: 'crm', text: 'CRM' },

                { value: 'cfe', text: 'CFE' },
                { value: 'dsi', text: 'DSI' },
                { value: 'das', text: 'DAS2' },
                { value: 'cva', text: 'CVAE' },
                { value: 'tvs', text: 'TVS' },
                { value: 'tss', text: 'TAXE SUR SALAIRES' },
            ],
        }
    },

    created() {
        this.initForm()
    },

    methods: {
        initForm() {
            this.form.description = this.comment.description
            this.form.type = this.comment.type.code
        },

        editForm() {
            this.editing = this.comment.can_edit
        },

        async deleteComment() {
            try {
                await axios.delete(`/clientEvents/${this.comment.id}`)
                this.show = false
                this.$emit('update')
            } catch (error) {
                console.log(error)
            }
        },

        async updateComment() {
            this.form.client_id = this.comment.client.id
            try {
                await axios.put(
                    `/clientEvents/${this.comment.id}/comment`,
                    this.form
                )
                this.editing = false
                this.$emit('update')
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped>
.comment-description {
    margin-bottom: 0;
}

.comment-created {
    font-size: 11px;
    margin-bottom: 0;
}
</style>
